import { render, staticRenderFns } from "./PreviewTemplateQuestion.vue?vue&type=template&id=1bcb302a&"
import script from "./PreviewTemplateQuestion.vue?vue&type=script&lang=js&"
export * from "./PreviewTemplateQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports